import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "inline-flex" }
const _hoisted_2 = { class: "bill-row" }
const _hoisted_3 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_icon = _resolveComponent("app-icon")!
  const _component_app_tooltip = _resolveComponent("app-tooltip")!
  const _component_project_row = _resolveComponent("project-row")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (!_ctx.hideInfoBtn && _ctx.el.Id > 0)
          ? (_openBlock(), _createBlock(_component_app_tooltip, {
              key: 0,
              text: _ctx.$t('info'),
              style: { height: '18px' }
            }, {
              activator: _withCtx(() => [
                _createVNode(_component_app_icon, {
                  class: "bill-row__info q-mr-xs",
                  name: "info-circle-outline",
                  width: "18px",
                  color: "#979797",
                  "hover-color": "#499259",
                  cursor: "pointer",
                  onClick: _withModifiers(_ctx.openInfoDialog, ["stop"])
                }, null, 8, ["onClick"])
              ]),
              _: 1
            }, 8, ["text"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass([
            'bill-row',
            { InvBillLink: _ctx.el.ConnectionsWithValuesInvalidated },
            { 'draft-text': _ctx.el.IsDraft && !_ctx.isPayment || _ctx.el.CreatedInCrm },
          ]),
          innerHTML: _ctx.displayHtml
        }, null, 10, _hoisted_3)
      ]),
      (!_ctx.hideRemoveBtn)
        ? (_openBlock(), _createBlock(_component_app_tooltip, {
            key: 0,
            text: _ctx.$t('remove'),
            style: { height: '16px' }
          }, {
            activator: _withCtx(() => [
              _createVNode(_component_app_icon, {
                class: "ml-1 bill-row__remove",
                name: "close",
                width: "16px",
                color: "#979797",
                "hover-color": "#616161",
                cursor: "pointer",
                onClick: _withModifiers(_ctx.detach, ["stop"])
              }, null, 8, ["onClick"])
            ]),
            _: 1
          }, 8, ["text"]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.el.Connections && _ctx.el.Connections.filter(el => el.Project).length)
      ? (_openBlock(), _createElementBlock("div", {
          key: 'imp-' + (_ctx.el.Id ?? 0)
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.el.Connections.filter(el => el.Project), (project, pi) => {
            return (_openBlock(), _createBlock(_component_project_row, {
              key: 'imp-' + pi,
              class: "q-mb-xs",
              el: project.Project,
              "hide-remove-btn": true,
              onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
            }, null, 8, ["el"]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}